import { RichText } from "@wordpress/block-editor";
import { createBlock } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import React from "react";
import {
	useBlockStyle,
	useClientId,
	useCopyPasteStyles,
	useDeviceType,
} from "../../hooks";
import { EditProps } from "../../types";
import { cn } from "../../utils";
import InspectorControls from "./components/InspectorControls";

interface Props extends EditProps<any> {
	mergeBlocks: () => void;
	onReplace: () => void;
	onRemove: () => void;
}

const Edit: React.ComponentType<Props> = (props) => {
	const {
		attributes: { text, typography, cssID, className },
		setAttributes,
	} = props;
	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "paragraph",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	return (
		<>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls={true} />
			<Style />
			<RichText
				id={cssID ? cssID : null}
				className={cn(
					`mzb-paragraph mzb-paragraph-${clientId}`,
					typography?._className,
					className
				)}
				identifier="content"
				tagName="p"
				onSplit={(value: string) => {
					let newAttributes;

					if (value) {
						newAttributes = {
							...props.attributes,
							text: value,
						};
					}

					const block = createBlock(
						"magazine-blocks/paragraph",
						newAttributes
					);

					return block;
				}}
				onMerge={props.mergeBlocks}
				onReplace={props.onReplace}
				onRemove={props.onRemove}
				data-empty={!text}
				placeholder={__("This is Paragraph.", "magazine-blocks")}
				value={text}
				onChange={(val) => {
					setAttributes({ text: val });
				}}
			/>
		</>
	);
};

export default Edit;
